<div (click)="toggleMenu($event)" (clickOutside)="closeActionMenu($event)" class="dots" id="Dots_Bulk">
    <div (click)="toggleMenu($event)" class="dots" id="HeaderRowDots">...</div>
</div>
